import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {getMateriality, useSelectedStEntityId} from '../../../util/Ares/customHooks';
import {useEngagementId} from '../../../util/customHooks';
import Fetch from '../../Common/Fetch/fetch';
import {getTaskDocumentByDocumentId} from '../../../selectors/Ares/selectors';

export default function MaterialityFetch(props) {
	const {children, documentId, trackWithArea} = props;

	const engagementId = useEngagementId();
	const [selectedStEntityId] = useSelectedStEntityId();

	const dispatch = useDispatch();

	const aresFormData = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));

	const fetch = useCallback(() => {
		return dispatch(getMateriality(engagementId, selectedStEntityId, trackWithArea));
	}, [selectedStEntityId]);

	return (
		<React.Fragment>
			{aresFormData && <Fetch fetch={fetch}>{React.cloneElement(children, {getMateriality: fetch})}</Fetch>}
		</React.Fragment>
	);
}

MaterialityFetch.propTypes = {
	children: PropTypes.node,
	documentId: PropTypes.string
};
